/**
 * Define el modelo de SSOInformation
 *
 * *Defines SSO Information model*
 *
 * @type {class}
 */
export class SSOInformation {

  /**
   *  Constructor de la clase
   * *Class Contstructor.*
   *
   * @param {string} accessToken Sets value
   * @param {number} expiresIn Sets value, not mandatory
   * @param {number} refreshExpiresIn Sets value, not mandatory
   * @param {string} refreshToken Sets value, not mandatory
   * @param {string} tokenType Sets value, not mandatory
   * @param {number} notBeforePolicy Sets value, not mandatory
   * @param {string} sessionState Sets value, not mandatory
   * @param {string} scope Sets value, not mandatory
   */
  constructor(
    public accessToken: string,
    public expiresIn?: number,
    public refreshExpiresIn?: number,
    public refreshToken?: string,
    public tokenType?: string,
    public notBeforePolicy?: number,
    public sessionState?: string,
    public scope?: string,
  ) { }
}
